import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-language',
  templateUrl: './language.component.html'
})
export class LanguageComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
